import React from "react";
import { View, styled, useComposedRefs, useEvent, useTheme } from "@tamagui/core";
import { registerFocusable } from "@tamagui/focusable";
import { styledBody } from "./shared.mjs";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
const StyledInput = styled(View, styledBody[0], styledBody[1]),
  Input = StyledInput.styleable((inProps, forwardedRef) => {
    const {
        // some of destructed props are just to avoid passing them to ...rest because they are not in web.
        allowFontScaling,
        selectTextOnFocus,
        showSoftInputOnFocus,
        textContentType,
        passwordRules,
        textBreakStrategy,
        underlineColorAndroid,
        selection,
        lineBreakStrategyIOS,
        returnKeyLabel,
        disabled,
        onSubmitEditing,
        caretHidden,
        clearButtonMode,
        clearTextOnFocus,
        contextMenuHidden,
        dataDetectorTypes,
        id,
        enablesReturnKeyAutomatically,
        importantForAutofill,
        inlineImageLeft,
        inlineImagePadding,
        inputAccessoryViewID,
        keyboardAppearance,
        keyboardType,
        cursorColor,
        disableFullscreenUI,
        editable,
        maxFontSizeMultiplier,
        multiline,
        numberOfLines,
        onChangeText,
        onContentSizeChange,
        onEndEditing,
        onScroll,
        onSelectionChange,
        caretColor,
        placeholderTextColor,
        blurOnSubmit,
        enterKeyHint,
        returnKeyType,
        rejectResponderTermination,
        scrollEnabled,
        secureTextEntry,
        selectionColor,
        inputMode,
        ...rest
      } = inProps,
      ref = React.useRef(null),
      theme = useTheme(),
      composedRefs = useComposedRefs(forwardedRef, ref),
      _onSelectionChange = useEvent(() => {
        const start = ref.current?.selectionStart ?? 0,
          end = ref.current?.selectionEnd ?? 0;
        onSelectionChange?.({
          nativeEvent: {
            selection: {
              end,
              start
            }
          }
        });
      });
    React.useEffect(() => {
      if (onSelectionChange) return ref.current?.addEventListener("selectionchange", _onSelectionChange), () => {
        ref.current?.removeEventListener("selectionchange", _onSelectionChange);
      };
    }, []), React.useEffect(() => {
      selection && ref.current?.setSelectionRange(selection.start || null, selection.end || null);
    }, [selection?.start, selection?.end]);
    const finalProps = {
      ...rest,
      inputMode,
      disabled,
      caretColor,
      id,
      enterKeyHint,
      style: {
        ...rest.style,
        ...(placeholderTextColor && {
          "--placeholderColor": theme[placeholderTextColor]?.variable || placeholderTextColor
        }),
        ...(selectionColor && {
          "--selectionColor": theme[selectionColor]?.variable || selectionColor
        })
      }
    };
    return React.useEffect(() => {
      if (id && !disabled) return registerFocusable(id, {
        focusAndSelect: () => {
          ref.current?.focus();
        },
        focus: () => {}
      });
    }, [id, disabled]), /* @__PURE__ */jsxs(Fragment, {
      children: [/* @__PURE__ */jsx("style", {
        children: `
      input::selection, textarea::selection {
        background-color: var(--selectionBackground) !important;
      }
      
      input::placeholder, textarea::placeholder {
        color: var(--placeholderColor) !important;
      }
      `
      }), /* @__PURE__ */jsx(StyledInput, {
        ref: composedRefs,
        ...finalProps
      })]
    });
  });
export { Input };
//# sourceMappingURL=Input.mjs.map
